"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/congrid/configModal");
exports.initialState = {
    isOpen: false,
    key: ''
};
const isOpen = monocle.Lens.fromProp('isOpen');
const key = monocle.Lens.fromProp('key');
exports.methods = {};
exports.methods[ActionTypes.TOGGLE_MODAL] = (state) => {
    return isOpen.set(!isOpen.get(state))(state);
};
exports.methods[ActionTypes.SET_KEY] = (state, action) => {
    return key.set(action.payload)(state);
};
exports.methods[ActionTypes.CLEAR] = (state) => {
    return Object.assign({}, state);
};
//# sourceMappingURL=configModal.js.map